<template>
  <div class="box" :class="canUse ? '' : 'layerbox'">
    <div v-if="canUse" class="wrapper">
      <div class="qrcode-wrapper">
        <canvas ref="qrcode_dom"></canvas>
        <div class="masker" v-show="is_out_of_time">
          <div class="reflash-icon" :class="{ reflashing: is_reflashing}" @click="requireQrcode"></div>
        </div>
      </div>
      <div class="qrcode-tip">{{ qrcode_tip }}</div>
    </div>
    <img src="../assets/unuse.png" v-else>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import axios from 'axios'

import { mapState, mapMutations } from 'vuex'
import { UPDATE_UID, UPDATE_DELTA_HEIGHT } from '../store/mutation-type'

export default {
  data () {
    return {
      qrcode: '', // 二维码
      qrcode_tip: '扫描二维码登录', // 二维码下提示语
      is_out_of_time: true, // 二维码是否过期
      is_reflashing: false, // 是否正在更新
      can_get_scan_result: false, // 能否轮询扫码结果
      marginTop: '0px',
      canUse: true
    }
  },
  computed: {
    ...mapState(['config', 'deltaHeight'])
  },
  watch: {
    qrcode (newVal, oldVal) { // 监听qrcode的变化并维持二维码最新
      this.is_reflashing = false // 结束二维码请求动画
      QRCode.toCanvas(this.$refs.qrcode_dom, newVal, { // 通过qrcode库绘制二维码
        scale: 10,
        errorCorrectionLevel: 'high',
        width: 300,
        color: {
          dark: '#000000',
          light: '#ffffff'
        }
      }, (error) => {
        if (error) {
          console.log('绘制二维码失败')
          console.error(error)
        }
        this.qrcode_tip = '扫描二维码登录'
        this.is_out_of_time = false // 二维码生效
        this.can_get_scan_result = true // 开启轮询
        this.getScanQrResult()
        setTimeout(() => { // 限制二维码有效期，有效期为config.QRCODE_LIMIT
          this.can_get_scan_result = false // 停止轮询
          this.is_out_of_time = true // 二维码失效
          this.qrcode_tip = '二维码已失效，请重新点击刷新图标'
        }, this.config.QRCODE_LIMIT)
      })
    }
  },
  beforeMount () {
    this.requireQrcode()
  },
  methods: {
    ...mapMutations({
      updateUid: UPDATE_UID,
      updateDeltaHeight: UPDATE_DELTA_HEIGHT
    }),
    requireQrcode () { // 请求二维码
      this.is_reflashing = true // 开启二维码请求动画
      axios({
        url: `${this.config.API_ROOT}/voibook/web/getWebToken`,
        method: 'get'
      }).then(data => {
        data = data.data
        if (data.code === 0) {
          this.qrcode = data.data.webToken
          sessionStorage.setItem('webToken', this.qrcode.slice(this.qrcode.lastIndexOf('/') + 1))
        }
      })
    },
    getScanQrResult () { // 使用this.can_get_scan_result限制一段时间内不会同时发出好几个请求
      if (this.can_get_scan_result) {
        this.can_get_scan_result = false // 限制暂时无法使用此函数发出请求
        axios({
          url: `${this.config.API_ROOT}/voibook/web/checkWebToken`,
          method: 'post',
          data: {
            webToken: sessionStorage['webToken']
          }
        }).then(data => {
          data = data.data
          this.can_get_scan_result = true // 本次请求结束，可以继续发送请求了
          switch (data.code) {
            case 0: {
              console.log('扫码登陆成功')
              let { uid, token, expiresTimeStamp } = data.data
              // 记录customToken 和 token 和 有效期
              this.updateUid(uid) // customToken提交到vuex中
              sessionStorage.setItem('token', token) // token保存在sessionStorage
              sessionStorage.setItem('expiry', expiresTimeStamp) // 将有效期也保存到sessionStorage中
              this.$router.push('/Main')
              break
            }
            case 52012: {
              console.log('授权时间过期')
              return this.$router.push('/Nopay')
            }
            case 61018: {
              console.log('未进行扫码确认')
              setTimeout(this.getScanQrResult, 2000) // 2秒后再次发送请求
              break
            } default: {
              console.log('登录失败，请刷新页面后重试')
              this.$alert({ message: '登录失败，请刷新页面后重试' })
            }
          }
        })
      }
    }
  },
  async mounted () {
    // 设置加载页面的居中样式
    // let clientHeight = this.$el.clientHeight
    // let screenHeight = window.screen.height
    // let deltaHeight = (screenHeight - clientHeight - 20) / 2
    // this.updateDeltaHeight(deltaHeight)
    // this.marginTop = -(deltaHeight + 260) + 'px'
    // 判断浏览器类型
    if (navigator.userAgent.indexOf('MSIE') >= 1) {
      this.canUse = false
    }
  }
}
</script>

<style scoped>
.box {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.layerbox {
  background: rgba(0,0,0,.25)
}
.box>img {
  position: absolute;
  left: 50%;
  top: 50%;
  width:500px;
  margin-left:-200px;
  margin-top: -200px;
}
.wrapper {
  position: absolute;
  border-radius: 4px;
  width:340px;
  height: 340px;
  left: 50%;
  top: 50%;
  box-shadow: 0 0 6px #ccc;
  padding:20px;
  text-align: center;
  /* margin-left: -190px;
  margin-top: -280px; */
  transform: translate(-50%, -60%);
}
.qrcode-wrapper {
  position: relative;
}
.masker {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(255,255,255,0.9);
}
.reflash-icon {
  position: absolute;
  border-radius: 50%;
  box-shadow: 0px 0px 10px #999;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: url('../assets/refresh.png') center center / 50% 50% no-repeat #fff;
  width: 90px;
  height: 90px;
  cursor: pointer;
}
.reflashing {
  animation: rotate_icon 1s linear 0 infinite;
}
@keyframes rotate_icon {
  from {transform: rotate(0deg);}
  to {transform: rotate(180deg);}
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue